import { useContext } from 'react';
import auth from './auth';
import { authContext } from './AuthProvider';

const useAuth = () => {
    const {user, setUser, idToken, setIdToken, claim, setClaim} = useContext(authContext);

    const signIn = async (data, cb, cbError) => {
        return auth.signIn(data, (username, token, newClaim) => {
            setUser(username);
            setClaim(newClaim);
            setIdToken(token);
            if (cb && typeof cb === 'function') {
                cb();
            }
        }, cbError);
    };

    const signOut = cb => {
        return auth.signOut(() => {
            setUser(null);
            if (cb && typeof cb === 'function') {
                cb();
            }
        });
    };

    return {
        user,
        signIn,
        signOut,
        idToken,
        claim,
    };
}

export default useAuth;